module.exports = __webpack_public_path__ + "img/screen-homepage.daa25fdf.jpg";